import {cloneDeep} from "lodash";
import {FILE_SIZES} from "../../../../constants/file-sizes.constant";

export const DigitalLayoutController = ($scope,
                                              $mdDialog, callback, company, overlay, startScreenDesign, background, logo, showLogo, activeMode) => {
    "ngInject";


    // if json provided than clone configuration
    $scope.sourceConfig && ($scope.configuration.json = $scope.sourceConfig.json);

    $scope.overlay = overlay;
    $scope.callback = callback;
    $scope.company = company;
    $scope.startScreenDesign = startScreenDesign;
    $scope.background = background;
    $scope.savedFile = $scope.startScreenDesign ? cloneDeep($scope.background.file) : null;
    $scope.savedColor = $scope.startScreenDesign ? cloneDeep($scope.background.color) : null;
    $scope.logo = logo;
    $scope.showLogo = $scope.startScreenDesign ? showLogo : false;
    $scope.activeMode = activeMode;
    $scope.single = $scope.activeMode === "single";
    $scope.fileSizes = FILE_SIZES;
    $scope.photos = [
        {
            width: 500,
            height: 500,
            x: 0,
            y: 0,
            image: $scope.activeMode === "single",
            gif: $scope.activeMode === "gif",
            video: $scope.activeMode === "boomerang"
        }
    ];

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        let data = {
            overlay: $scope.overlay,
            startScreenDesign: $scope.startScreenDesign
        };
        $scope.callback(data);
        $mdDialog.hide();
    };

    $scope.deleteFile = () => {
        $scope.overlay = null;
    };

    $scope.onChangeOption = () => {
        if ($scope.startScreenDesign) {
            $scope.savedFile = cloneDeep($scope.background.file);
            $scope.savedColor = cloneDeep($scope.background.color);
            $scope.showLogo = true;
        } else {
            $scope.savedFile = null;
            $scope.savedColor = null;
            $scope.showLogo = false;
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/configurations/quick-setup/digital-layout/digital-layout.js